export function registrarEvento(nome: string, parametros: object) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(
      'event',
      nome
        ?.replace(/\s/g, '')
        ?.normalize('NFD')
        ?.replace(/[\u0300-\u036f]/g, ''),
      {
        ...parametros,
      },
    );
  } else {
    console.error('Google Analytics não está configurado.');
  }
}
